export default new class Form {
  constructor() {
    this.sButtonLoyaltyProgramClass = '_loyalty_program_button';
    this.sFormLoyaltyProgramClass = '_loyalty_program_form';

    this.sButtonEventClass = '_event_button';
    this.sFormEventClass = '_event_form';

    this.sButtonLessonClass = '_lesson_button';
    this.sFormLessonClass = '_lesson_form';

    this.sDialogOpenerSuccessClass = 'dialog-opener-success';
    this.sDialogOpenerFailClass = 'dialog-opener-fail';
    this.sDialogCloseClass = 'dialog__close';

    this.obDialogButtonSuccess = null;
    this.obDialogButtonFail = null;
    this.obDialogButtonClose = null;

    this.sInvalidClass = '_invalid';

    this.obEvent = null;

    this.sendLoyaltyProgram();
    this.sendEvent();
    this.sendLesson();
  }

  sendLoyaltyProgram() {
    $(document).on("click", `.${this.sButtonLoyaltyProgramClass}`, (obEvent) => {
      this.obEvent = obEvent;
      const self = this;

      $(document).ready(function () {
        self.obDialogButtonSuccess = $(`.${self.sDialogOpenerSuccessClass}`);
        self.obDialogButtonFail = $(`.${self.sDialogOpenerFailClass}`);

        const obButton = $(self.obEvent.target);
        const obForm = obButton.closest('form');

        if (obForm.hasClass(self.sInvalidClass)) {
          return;
        }

        obButton.attr('disabled', 'disabled');

        $.request("Form::onLoyaltyProgram", {
          form: obForm,
          complete: function (obResponse) {
            if (obResponse.responseJSON.status === true) {
              self.obDialogButtonSuccess.click();
              $(`.${self.sFormLoyaltyProgramClass}`)[0].reset();
            } else {
              self.obDialogButtonFail.click();
            }
            $(self.obEvent.target).removeAttr('disabled');
          }
        });
      });
    });
  }

  sendEvent() {
    $(document).on("click", `.${this.sButtonEventClass}`, (obEvent) => {
      this.obEvent = obEvent;
      const self = this;

      $(document).ready(function () {
        self.obDialogButtonSuccess = $(`.${self.sDialogOpenerSuccessClass}`);
        self.obDialogButtonFail = $(`.${self.sDialogOpenerFailClass}`);
        self.obDialogButtonClose = $(`.${self.sDialogCloseClass}`);

        const obButton = $(self.obEvent.target);
        const obForm = obButton.closest('form');

        if (obForm.hasClass(self.sInvalidClass)) {
          return;
        }

        obButton.attr('disabled', 'disabled');

        $.request("Form::onEvent", {
          form: obForm,
          complete: function (obResponse) {
            self.obDialogButtonClose.click();
            $(`.${self.sFormEventClass}`)[0].reset();
            if (obResponse.responseJSON.status === true) {
              self.obDialogButtonSuccess.click();
            } else {
              self.obDialogButtonFail.click();
            }
            $(self.obEvent.target).removeAttr('disabled');
          }
        });
      });
    });
  }

  sendLesson() {
    $(document).on("click", `.${this.sButtonLessonClass}`, (obEvent) => {
      this.obEvent = obEvent;
      const self = this;

      $(document).ready(function () {
        self.obDialogButtonSuccess = $(`.${self.sDialogOpenerSuccessClass}`);
        self.obDialogButtonFail = $(`.${self.sDialogOpenerFailClass}`);
        self.obDialogButtonClose = $(`.${self.sDialogCloseClass}`);

        const obButton = $(self.obEvent.target);
        const obForm = obButton.closest('form');

        if (obForm.hasClass(self.sInvalidClass)) {
          return;
        }

        obButton.attr('disabled', 'disabled');

        $.request("Form::onLesson", {
          form: obForm,
          complete: function (obResponse) {
            self.obDialogButtonClose.click();
            $(`.${self.sFormLessonClass}`)[0].reset();
            if (obResponse.responseJSON.status === true) {
              self.obDialogButtonSuccess.click();
            } else {
              self.obDialogButtonFail.click();
            }
            $(self.obEvent.target).removeAttr('disabled');
          }
        });
      });
    });
  }
}();
